import styled, { css } from "styled-components";
import { shimmer } from "../common";

export const SkeletonContainer = styled.div`
    width: 100%;
    padding: 10px;
    display: flex;
    cursor: pointer;
    border: 1px solid #3f3f4670;
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.07);
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
    height: 115px;

    > * + * {
        margin-left: 10px;
    }

    &:hover {
        border: 1px solid #d4d4d8;
    }
`

export const SkeletonImage = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 15px;
    background-color: #FFFFFF10;
    ${shimmer}
`

export const SkeletonText = styled.div<{ width: string; height: string; }>`
    border-radius: 5px;
    background-color: #FFFFFF10;
    ${shimmer}
    
    ${({ width, height }) => css`
        width: ${width};
        height: ${height};
    `}
`

export const Wrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

export const Flex = styled.div`
    flex: 1;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
`